/**
 * colours.js — shared colour data used across the app.
 */

/** Spine colours for the reading bookshelf */
export const SPINE_COLORS = [
  '#2E7D3E', '#52A96A', '#238b45', '#7BBFA0',
  '#3d8b6e', '#1a6b34', '#5aab7a', '#8fbd6e',
  '#4a9e6e', '#2d6b4a',
]

/** Mood colours matching the 5 emotional states */
export const MOOD_COLORS = {
  sad:     '#5a8fc4',
  anxious: '#c4963a',
  calm:    '#52A96A',
  happy:   '#238b45',
  excited: '#A8C96A',
}

/** Colour walk colour palette */
export const COLOUR_WALK_PALETTE = [
  { name: 'Terracotta', hex: '#C1714A', prompt: 'Find something the colour of warm earth — a brick, a pot, a roof tile.' },
  { name: 'Sage green', hex: '#7A9E7E', prompt: 'Spot something quietly green — a leaf, a painted door, a mossy wall.' },
  { name: 'Dusty blue', hex: '#7B9EB8', prompt: 'Look for muted blue — sky between clouds, a faded sign, a piece of denim.' },
  { name: 'Cream',      hex: '#F0E6C8', prompt: 'Find something soft and pale — old paper, a stone wall, a flower petal.' },
  { name: 'Rust',       hex: '#B25E38', prompt: 'Notice rust or burnt orange — an autumn leaf, old metal, a fox.' },
  { name: 'Slate',      hex: '#7A8C94', prompt: 'Spot grey with warmth — a pebble, a pigeon, a weathered post.' },
  { name: 'Butter',     hex: '#E8D27A', prompt: 'Find gentle yellow — sunlight on a wall, a dandelion, a taxi.' },
  { name: 'Plum',       hex: '#7B5C78', prompt: 'Look for deep purplish tones — lavender, a shadow, evening light.' },
  { name: 'Forest',     hex: '#3D6B4F', prompt: 'Find deep green — ivy, a dark hedge, a pine tree.' },
  { name: 'Blush',      hex: '#D4897A', prompt: "Spot something pinkish — a petal, a sunset, someone's cheeks." },
]
